import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getConversationMessages = store => store[NAME].conversationMessages;